/* eslint-disable linebreak-style */
import React from 'react';
const JobLossHardshipStepShared = () => (
  <ol>
    <li>
    Provide HR notice of termination that includes period worked with the employer
    </li>
    <li>
    Proof of filing for unemployment benefits (if recent) or receipt of benefits
    </li>
    <li>
    Proof of Outstanding Dues (invoice or other documentation received from developer)
    </li>
  </ol>
);

export default JobLossHardshipStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.DuesProtect.JobLossHardshipStep/components/JobLossHardshipStepShared.js